import * as Yup from 'yup'
import { COURIER } from 'domains/merchant-inbound/constants/merchant-inbound-pickup-constants'

const MerchantInboundSchedulePickupSchema = Yup.object().shape({
  scheduled_at : Yup.date().min(new Date(), 'Date harus lebih besar dari hari ini'),
  courier      : Yup.string().oneOf(
    Object.values(COURIER),
    `Harus satu dari ${Object.values(COURIER).join(', ')}`
  ).required('Required')
})

export default MerchantInboundSchedulePickupSchema